import React, { Dispatch, SetStateAction } from "react";
import { IMessage, IUserId, IVisibleTo } from "@home-health-notify/domain";
import MessageDetail from "./MessageDetail";
import { IChatInfoAccess } from "hhn-commons";

interface AskForAcknowledgementProps {
  message: IMessage;
  recipients: IVisibleTo[];
  isLoading: boolean;
  setSelectedUsers: Dispatch<SetStateAction<IUserId[]>>;
  selectedUsers: IUserId[];
  chatInfoAccess: IChatInfoAccess;
}

const AskForAcknowledgement = ({
  message,
  recipients,
  isLoading,
  setSelectedUsers,
  selectedUsers,
  chatInfoAccess,
}: AskForAcknowledgementProps) => {
  return (
    <MessageDetail
      message={message}
      recipients={recipients}
      isLoading={isLoading}
      showSearch
      enableAcknowledgement
      setSelectedUsers={setSelectedUsers}
      selectedUsers={selectedUsers}
      chatInfoAccess={chatInfoAccess}
    />
  );
};

export default AskForAcknowledgement;
